import React from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import fetchUtil from '../../utils/fetchUtil';
import ErrorComponent from '../../components/ErrorComponent';
import FranchiseeComponent from '../../components/StudyAbroad/FranchiseeComponent';
import { Props } from 'react-select';
import { CACHE_REVALIDATE_24H } from '../../utils/constants';

const FranchiseePage: React.FC = (props: any) => {
    if (!props.pageData || props.pageData.length === 0) {
        return <ErrorComponent />
    }

    return (
        <FranchiseeComponent eventData={props.pageData[0]} />
    )
}

export const getStaticPaths: GetStaticPaths = async () => {
    return { paths: [], fallback: 'blocking' };
}

export const getStaticProps: GetStaticProps = async (context) => {
    const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/franchisee-pages?slug=${context.params?.slug}&categoryType=franchisee`, 'GET', {}, '', false)
    return {
        props: {
            pageData
        },
        revalidate: CACHE_REVALIDATE_24H,
    };
}

export default FranchiseePage;
